import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import { IMessage } from '@/api/types'
import {
  IPlatformsPayload,
  IPlatformsResponse
} from '@/apps/traforama/interfaces/websites'

export const getMarketplacePlatforms = async (
  payload: IPlatformsPayload
): Promise<IPlatformsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start, csv: !!payload.csv },
    nestedQueryFormatter('filter', payload.filter),
    nestedQueryFormatter('sorter', payload.sorter)
  )
  const response = await apiClient.get<IPlatformsResponse>(
    '/platforms/marketplace',
    { params: params }
  )
  return response.data
}

export const sendMessage = async (
  payload: IMessage
): Promise<IPlatformsResponse> => {
  const response = await apiClient.post<IPlatformsResponse>(
    '/platforms/message',
    payload
  )
  return response.data
}

export const fetchItems = async (
  payload: IPlatformsPayload
): Promise<IPlatformsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter)
  )
  const response = await apiClient.get<IPlatformsResponse>('/platforms', {
    params: params
  })
  return response.data
}
